import { endPointPrivate } from './config'
import axios from 'axios'

export default {
  listarPaginacaoClientes: () => {
    return axios.get(endPointPrivate + 'v1/relatorioClientesPaginacao')
  },
  listarClientes: (param) => {
    return axios.get(endPointPrivate + 'v1/relatorioClientes?' + 'tipoRelatorio=' + param.tipoRelatorio + '&paginacao=' + param.paginacao + '&registrosPorPagina=' + param.registrosPorPagina)
  },
  listarAnosMetas: () => {
    return axios.get(endPointPrivate + 'v1/anosMeta')
  },
  listarCatRepresentante: () => {
    return axios.get(endPointPrivate + 'v1//categoriasRepresentante')
  },
  MetasVsAtingido: (param) => {
    return axios.get(endPointPrivate + 'v1/metasVsAtingido?' + 'ano=' + param.ano + '&codCategoria=' + param.codCategoria)
  },
  resumoComissoes: (param) => {
    return axios.get(endPointPrivate + 'v1/comissaoRepresentante?qtdeDias=180')
  },
  resumoComissoesCategoria: (periodo) => {
    return axios.get(endPointPrivate + 'v1/comissaoRepresentanteCategoria?periodo=' + periodo)
  },
  resumoGerencialPeriodo: (param) => {
    return axios.get(endPointPrivate + 'v1/relatorioGerencial?codRepresentante=' + param.codRepresentante + '&dataDe=' + param.dataDe + '&dataAte=' + param.dataAte)
  },
  listarMetas: (param) => {
    return axios.get(endPointPrivate + 'v1/metasVsAtingido?' + 'mes=' + param.mes + '&ano=' + param.ano)
  },
  listarComissao: (param) => {
    return axios.get(endPointPrivate + 'v1/comissaoRepresentante?' + 'mes=' + param.mes + '&ano=' + param.ano)
  },
  enviar: (parametros) => {
    return axios.post(endPointPrivate + 'v1/comissaoMesRepresentante', parametros)
  }
}



// WEBPACK FOOTER //
// ./src/services/relatorios.js